import fromExponential from 'from-exponential';
import { AssetFormat, ContributionDetailItem } from 'services/requests';
import { formatUSD } from 'utils';
import { mapIndependentIraTypeKeyToValue } from 'screens/IndependentIra/IraIndependentIra.utils';
import { CustomColumn } from 'components/Table/Table.types';

import styles from './ContributionDetails.module.css';

export type MapData = ContributionDetailTableSign[];

export type ContributionDetailTableSign = Omit<
  ContributionDetailItem,
  'asset' | 'fiatEquivalent'
> & {
  asset: string;
  fiatEquivalent: string;
};

export const mapData = (
  data: ContributionDetailItem[] | undefined,
): MapData | undefined =>
  data?.map((contributionDetailItem: ContributionDetailItem) => ({
    ...contributionDetailItem,
    asset:
      contributionDetailItem.asset.assetFormat === AssetFormat.FIAT
        ? formatUSD(contributionDetailItem.asset.amount)
        : `${fromExponential(contributionDetailItem.asset.amount)} ${
            contributionDetailItem.asset.code
          }`,
    fiatEquivalent:
      contributionDetailItem.fiatEquivalent &&
      contributionDetailItem.asset.assetFormat !== AssetFormat.FIAT
        ? formatUSD(contributionDetailItem.fiatEquivalent)
        : '\u2013',
    userProfileType: mapIndependentIraTypeKeyToValue(
      contributionDetailItem.userProfileType,
    ),
  }));

export const columns: CustomColumn<ContributionDetailTableSign>[] = [
  {
    Header: 'Email',
    accessor: 'email',
    className: styles.emailColumn,
  },
  {
    Header: 'Profile type',
    accessor: 'userProfileType',
    className: styles.profileTypeColumn,
  },
  {
    Header: 'Amount',
    accessor: 'asset',
    className: styles.amountColumn,
  },
  {
    Header: 'Est. cost basis',
    accessor: 'fiatEquivalent',
    className: styles.fiatColumn,
  },
  {
    Header: 'Contribution type',
    accessor: 'contributionType',
    className: styles.contributionTypeColumn,
  },
];
